<form [formGroup]="formGroup">
  <p-autoComplete
    [inputId]="formCtrlId"
    formControlName="searchValue"
    [suggestions]="bankaSuggestions"
    field="naziv"
    [delay]="0"
    [minLength]="1"
    [showEmptyMessage]="true"
    emptyMessage="Nema rezultata"
    appendTo="body"
    pTooltip="Unesite naziv banke za pretragu"
    (completeMethod)="handleSearch($event)"
    (onSelect)="selectionChanged($event)"
    (onClear)="onClear()"
    (onBlur)="onBlur()"
  >
    <ng-template let-banka pTemplate="item">
      <div class="p-d-flex p-flex-column">
        <span class="p-text-bold">{{ banka.naziv }}</span>
        <span *ngIf="banka.bic" class="p-text-secondary">{{ banka.bic }}</span>
      </div>
    </ng-template>
  </p-autoComplete>
  <kodit-error-info-required
    [formCtrl]="formGroup.controls.searchValue"
  ></kodit-error-info-required>
</form>
